// Wearable identification (renderer side). Keep in sync with the copy in
// electron/main.js (isWearablePort).
//
// The wearable is an nRF (Nordic) USB CDC device: USB vendor id 0x1915 and
// manufacturer string "Nordic Semiconductor". That is what distinguishes it
// from the host's own ports (debug-console, Bluetooth-Incoming-Port, generic
// USB-serial adapters) in the port list.

import { t } from "i18n";

export const NORDIC_VENDOR_ID = "1915";

export const isWearablePort = (port) => {
  if (!port) return false;
  const vid = String(port.vendorId || "").toLowerCase();
  const mfr = String(port.manufacturer || "");
  return vid === NORDIC_VENDOR_ID || /nordic/i.test(mfr);
};

// Wearable ports from a list, best candidate first. When a device exposes more
// than one node (e.g. a data CDC plus a debug console), prefer the callable
// usbmodem/ACM node the console actually lives on.
export const wearablePorts = (ports = []) => {
  const matches = ports.filter(isWearablePort);
  return matches.sort((a, b) => {
    const score = (p) => (/usbmodem|ttyACM/i.test(p.path || "") ? 0 : 1);
    return score(a) - score(b);
  });
};

// A short, human label for a port row: the manufacturer if we have one, else
// the leaf of the device path.
export const portLabel = (port) =>
  port?.manufacturer ||
  (port?.path || "").split("/").pop() ||
  t("utils.wearablePort.serialDevice");
